import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-header-navigation-dropdown',
  styleUrl: 'spw-header-navigation-dropdown.scss',
  shadow: true,
})
export class SpwHeaderNavigationDropdown {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
